import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'contentType';

export class ContentType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
